// Central site-wide contact config.
// Edit these values to update contact info across the entire site.

export const SITE = {
  domain: "melohc.com",
  name: "Melo Hopeful Care LLC",
  slogan: "The Heart of Home Care",
  phones: [
    { display: "(402) 761-1531", tel: "+14027611531", label: "Primary" },
    { display: "(319) 237-2241", tel: "+13192372241", label: "Alternate" },
  ],
  email: "danielassa@melohc.com",
  address: {
    line1: "1724 S 74th St, Suite 210",
    line2: "Omaha, NE 68114",
    oneLine: "1724 S 74th St, Suite 210, Omaha, NE 68114",
  },
  hours: {
    office: "Mon–Fri 8a–6p",
    careLine: "24/7",
  },
  mapsEmbedUrl:
    "https://www.google.com/maps?q=1724+S+74th+St+Suite+210,+Omaha,+NE+68114&output=embed",
};

export const PRIMARY_PHONE = SITE.phones[0];
